import React from 'react';

import { Modal, Icon, Spin } from 'antd';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

/**
 * @component
 * @name OverlayFullScreenModal
 * @description It's the overlay full screen modal. 
 * It's typically shown when user clicks on search and book on form page, 
 * user clicks on search button and book now button on search page.
 * @param {Object} props Component props
 * @param {boolean} props.showModal Whether to show overlay full screen modal
 */
const OverlayFullScreenModal = ({ showModal }) => {
  return (
    <Modal
      title={null}
      destroyOnClose={true}
      footer={null}
      centered
      closeIcon={<span />}
      maskClosable={false}
      // onCancel={closeModal}
      visible={showModal}
      style={{}}
      bodyStyle={{ background: '#FFFFFF', borderRadius: '8px' }}
      className="testR1"
      width="auto"
    >
      <span
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Spin indicator={antIcon} className="testR1" />
        <span style={{ marginTop: '8px' }}>Please wait...</span>
      </span>
    </Modal>
  );
};

export default OverlayFullScreenModal;
